// eslint-disable-next-line import/no-extraneous-dependencies
import { serialize } from 'cookie';
import type { GetServerSidePropsContext } from 'next';
import type { Store } from 'redux';

import { authSetLoggedInAction } from '@/Module/Auth/Store/Slice/AuthSlice';

export const removeCookies = (context: GetServerSidePropsContext, store: Store) => {
  context.res.setHeader('Set-Cookie', [
    serialize('accessToken', '', {
      maxAge: -1,
      path: '/',
    }),
    serialize('refreshToken', '', {
      maxAge: -1,
      path: '/',
    }),
    serialize('refreshTime', '', {
      maxAge: -1,
      path: '/',
    }),
    serialize('examAccessToken', '', {
      maxAge: -1,
      path: '/',
    }),
  ]);

  store.dispatch(authSetLoggedInAction(false));
  return { props: {} };
};
